import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import classnames from 'classnames'
import { loadFont } from 'loankeeper-common/helpers/styles'
import styled from 'styled-components'
import LKButton from 'shared/LKButton'

import container from './newContainer'
// import container from './container'
import { ComponentContainer } from '../StyledComponents'

const StyledDropdown = styled(Dropdown)`
  ${(props) => loadFont(props.theme.buttonFont)};

  *:not(i) {
    ${(props) => loadFont(props.theme.buttonFont)};
  }

  .ui.item.simple.dropdown > .menu.transition.dropdown-menu {
    right: 100%;
    top: 0px !important;
  }

  &.menu--left .menu.transition {
    right: 3px;
    left: unset;
  }

  .ui.simple.dropdown > .menu {
    display: none;
  }

  .ui.simple.active.dropdown > .menu,
  .ui.simple.dropdown:hover > .menu {
    display: block;
  }
`

class LKPrintButton extends React.Component {
  state = { fetching: false, forceOpen: false }

  generatePrintPDFUrl = async (type, args) => {
    this.setState({ fetching: true })

    try {
      return await this.props.generatePrintPDFUrl(type, args)
    } finally {
      this.setState({ fetching: false })
    }
  }

  handleOpen = () => {
    this.setState({ fetching: true }, () => {
      this.props.handleOpen(() => {
        this.setState({ fetching: false })
      })
    })
  }

  handleOptionChange = (event, data) => {
    const { options, closeMenu } = this.props
    this.setState({ fetching: true }, () => {
      this.props.handleOptionChange(event, { ...data, options }, () => {
        this.setState({ fetching: false })
      })
    })
    closeMenu()
  }

  onFocus = () => this.setState({ forceOpen: true }, () => this.setState({ forceOpen: false }))

  render() {
    const {
      className,
      style,
      name,
      loading,
      isOpen,
      upward,
      closeMenu,
      leftward,
      options = [],
      buttonId,
      disabled,
      permission,
      chooseFormat,
      left,
      direction = 'down',
    } = this.props

    const { fetching } = this.state
    return (
      <ComponentContainer style={{ display: 'inline-block', width: 'auto' }} dropdown floatLeft={leftward}>
        <StyledDropdown
          className={classnames({
            'menu--left': left,
          })}
          trigger={
            <LKButton
              className={className}
              style={style}
              id={buttonId}
              loading={loading || fetching}
              disabled={loading || fetching || disabled}
              alias="print"
              permission={permission}
            >
              {name}
            </LKButton>
          }
          onFocus={this.onFocus}
          open={this.state.forceOpen || isOpen}
          openOnFocus={false}
          onOpen={this.handleOpen}
          onClose={closeMenu}
          loading={loading || fetching}
          disabled={loading || fetching || disabled}
          upward={upward}
          icon={null}
          onChange={this.handleOptionChange}
          options={options}
          selectOnBlur={false}
          leftward={leftward}
          value={null}
          item
          direction={direction}
        >
          {chooseFormat && (
            <Dropdown.Menu>
              {options.map((option) => (
                <Dropdown item simple text={option.text} value={option.value}>
                  <Dropdown.Menu className="dropdown-menu">
                    <Dropdown.Item
                      text="RTF ფორმატი"
                      value={option.value}
                      format="RTF"
                      onClick={this.handleOptionChange}
                    />
                    <Dropdown.Item
                      text="PDF ფორმატი"
                      value={option.value}
                      format="PDF"
                      onClick={this.handleOptionChange}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              ))}
            </Dropdown.Menu>
          )}
        </StyledDropdown>
      </ComponentContainer>
    )
  }
}

export default container(LKPrintButton)
